export default function (state = null, action, appShellData) {
    return appShellData.footer;
}
